module.exports = __webpack_public_path__ + "static/media/front.8ff83664.jpg";